var windowWidth,lazyImages,lazyBackground,lazyIframe,lazyScripts,src,style,datasrc,urls,analytics,s,x,i,j,flag;
document.addEventListener("DOMContentLoaded", function() {
	windowWidth = screen.width;
	lazyImages = document.querySelectorAll('img.lazy');
	nolazyImages = document.querySelectorAll('img.lazy2');
	lazyBackground = document.querySelectorAll('.lazybg');
	lazyIframe = document.querySelectorAll('iframe.lazy');
	lazyScripts = document.getElementsByTagName("script");
	i=0;
	j=0;
	flag=1;

	window.addEventListener("scroll", function() {
		init();
	});
	window.addEventListener("mousemove", function() {
		init();
	});
	window.addEventListener("touchstart", function() {
		init();
	});
	setTimeout(function() {
		init();
	}, 6000);
});
function init() {
	if(flag) {
		flag=0;
		lazyLoadImg();
		lazyLoadBackground();
		lazyLoadIframe();
		load_all_js();
	}
}
function lazyLoadImg() {
	lazyImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
		else
			src = elem.dataset.src;

		if( src != null )
			elem.src = src;

		elem.classList.remove("lazy");
	});
}
function lazyLoadBackground() {
	lazyBackground.forEach(function(elem) {
		if( windowWidth < 600 )
			lazybg = (elem.dataset.moblazybg == undefined) ? elem.dataset.style : elem.dataset.mobstyle;
		else
			lazybg = elem.dataset.style;

		if( lazybg != null )
			elem.style = lazybg;

		elem.classList.remove("lazybg");
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(function(elem) {
		elem.src = elem.dataset.src;
		elem.classList.remove("lazy");
	});
}
function lazyLoadScripts() {
	if (j == lazyScripts.length)
		return;

	if ( lazyScripts[j].getAttribute("type") == "lazyload2" ) {
		lazyScripts[j].setAttribute("type", "lazyloaded");
		if (typeof lazyScripts[j].dataset.src !== 'undefined') {
			s=document.createElement("script");
			s.src=lazyScripts[j].dataset.src;
			document.body.appendChild(s);
			s.onload=function() {
				j++;
				lazyLoadScripts();
			};
		} else {
			s=document.createElement("script");
			s.innerHTML=lazyScripts[j].innerHTML;
			document.body.appendChild(s);
			j++;
			lazyLoadScripts();
		}
	} else {
		j++;
		lazyLoadScripts();
	}
}
function lazyLoadCss(url) {
	s=document.createElement("link");
	s.rel="stylesheet";
	s.href=url;
	document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadJS(url) {
	s=document.createElement("script");
	s.src=url;
	document.body.appendChild(s);
}
function asyncLoad() {
	var urls = [
		"https://d1liekpayvooaz.cloudfront.net/apps/customizery/customizery.js?shop=canvasbackpets.myshopify.com",
		"https://app.zapiet.com/js/storepickup.js?shop=canvasbackpets.myshopify.com",
		"https://app.zapiet.com/js/v1.0/delivery-validator.js?shop=canvasbackpets.myshopify.com",
		"https://app.layouthub.com/shopify/layouthub.js?shop=canvasbackpets.myshopify.com",
		"https://d6vo2natd8u8k.cloudfront.net/1823375421/d969ce84-f731-468e-b3e3-460273d30e30.js?shop=canvasbackpets.myshopify.com"
	];

	for (i = 0; i < urls.length; i++) {
		s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = urls[i];
		x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}
}
function load_all_js() {
	lazyLoadCss("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
	lazyLoadCss("data:text/css;base64,");
	lazyLoadCss("//www.canvasbackpets.com/cdn/shop/t/12/assets/flexslider.css?v=54595018806342271481600721330");
	lazyLoadCss("//www.canvasbackpets.com/cdn/shop/t/12/assets/flexslider-product.css?v=58587010541517480141600721330");
	lazyLoadCss("//www.canvasbackpets.com/cdn/shop/t/12/assets/storepickup.scss.css?v=65365550471428489891600721330");

	
		asyncLoad();

		analytics = document.getElementsByClassName("analytics");
		s=document.createElement("script");
		s.type="text/javascript";
		s.innerHTML=analytics[0].innerHTML;
		x=document.getElementsByTagName("body")[0];
		x.appendChild(s);

		j=0;
		lazyScripts = document.getElementsByTagName("script");
		lazyLoadScripts();
	

	setInterval(function() {
		lazyImages = document.querySelectorAll('img.lazy');
		lazyLoadImg();
	}, 3000);
}